// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__k2hhP","modalFooterButton":"ModalNotes_modalFooterButton__3Qnoy"};